import { ModalEls, ModalKeyType } from 'common/modalEls.js';
import { useCallback, useEffect, useState } from 'react';
import { WindowHideInterstitialCB } from './fn-window-hide-interstitial-cb.js';

export const INTERSTITAL_WRAPPER = 'Modal-Component--content-interstitial';

export const InterstitialHook = (): {
  adDisplayTrueCB: () => void;
  adDisplayFalseCB: () => void;
} => {
  const [displayModal, setDisplayModal] = useState(false);

  /** Updates Modal classes to show hide */
  const { modalContent } = ModalEls({
    isModal: displayModal,
    modalComponentClasses: ['Modal-Component--interstitial'],
    key: ModalKeyType.Interstitial,
  });

  /**
   * Hides Interstital Modal When Closes
   * To Avoid Clashing When Modal is used by other Components
   */
  useEffect(() => {
    if (modalContent.current) {
      const interstitialElement = modalContent.current.querySelector(`div.${INTERSTITAL_WRAPPER}`);
      if (interstitialElement) {
        const intersitialClassList = interstitialElement.classList;
        const hasHiddenClass = intersitialClassList.contains('u-hidden');
        if (displayModal && hasHiddenClass) {
          intersitialClassList.remove('u-hidden');
        }
        if (!displayModal && !hasHiddenClass) {
          intersitialClassList.add('u-hidden');
        }
      }
    }
  }, [displayModal, modalContent]);

  /** Adds callback to window that ad wrapper calls to close on mount / unmount */
  WindowHideInterstitialCB({
    setDisplayModal,
  });

  /** Called from Ad Module To Hide Module */
  const adDisplayFalseCB = useCallback(() => {
    setDisplayModal(false);
  }, []);

  /** Called from Ad Module To Display Module */
  const adDisplayTrueCB = useCallback(() => {
    setDisplayModal(true);
  }, []);

  useEffect(() => {
    return () => {
      setDisplayModal(false);
    };
  }, []);

  return { adDisplayTrueCB, adDisplayFalseCB };
};
